"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CurrentAge = CurrentAge;
exports.CurrentContribution = CurrentContribution;
exports.EmployerMatchLimit = EmployerMatchLimit;
exports.EmployerMatchRate = EmployerMatchRate;
exports.EmployerMatchYN = EmployerMatchYN;
exports.FilingStatus = FilingStatus;
exports.PlanType = PlanType;
exports.RetTaxRate = RetTaxRate;
exports.RetirementAge = RetirementAge;
exports.Salary = Salary;
exports.State = State;
exports.TaxPreference = TaxPreference;
exports.TaxRate = TaxRate;
exports.WithdrawalAge = WithdrawalAge;
var _react = _interopRequireDefault(require("react"));
var _formikMiddleware = _interopRequireDefault(require("../../middleware/formikMiddleware"));
var _TraditionalvRothWizardCalc = require("./TraditionalvRothWizardCalc.config");
var _TextInputForNatLangForm = require("../Wizard/TextInputForNatLangForm");
var _DropdownForNatLangForm = require("../Wizard/DropdownForNatLangForm");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function CurrentAge(_ref) {
  var {
    errors,
    touched,
    values
  } = _ref;
  var fieldName = 'currentAge';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '3';
  var placeholder = '00';
  var htmlSize = '3';
  var preText = ' I am ';
  var postText = ' and I live in ';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_TraditionalvRothWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForNatLangForm.TextInputForNatLangForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    values: values,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    htmlSize: htmlSize,
    preText: preText,
    postText: postText,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _TraditionalvRothWizardCalc.idPrefix + fieldName
  });
}
function RetirementAge(_ref2) {
  var {
    errors,
    touched,
    values
  } = _ref2;
  var htmlSize = '3';
  var fieldName = 'retAge';
  var preText = " I plan to retire when I'm ";
  var postText = ' and begin making withdrawals ';
  var validateClass = touched.currentAge && errors[fieldName] && values.currentAge !== '' ? 'is-invalid' : '';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_TraditionalvRothWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForNatLangForm.TextInputForNatLangForm, {
    fieldName: fieldName,
    preText: preText,
    postText: postText,
    label: "Retirement Age",
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "numeric",
    maxLength: "3",
    htmlSize: htmlSize,
    placeholder: "00",
    prepend: false,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    className: validateClass,
    id: _TraditionalvRothWizardCalc.idPrefix + fieldName
  });
}
function WithdrawalAge(_ref3) {
  var {
    errors,
    touched,
    values
  } = _ref3;
  var htmlSize = '3';
  var fieldName = 'withdrawalAge';
  var preText = " from my retirement account when I'm ";
  var validateClass = touched.currentAge && errors[fieldName] && values.currentAge != '' ? 'is-invalid' : '';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_TraditionalvRothWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForNatLangForm.TextInputForNatLangForm, {
    fieldName: fieldName,
    preText: preText,
    label: "Withdrawal Age",
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "numeric",
    maxLength: "3",
    htmlSize: htmlSize,
    placeholder: "00",
    prepend: false,
    append: false,
    className: "endOfSentence ".concat(validateClass),
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _TraditionalvRothWizardCalc.idPrefix + fieldName
  });
}
function Salary(_ref4) {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = _ref4;
  var fieldName = 'salary';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var placeholder = '000,000';
  var htmlSize = '10';
  var preText = ' I make ';
  var postText = ' a year and last year, my tax rate ';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_TraditionalvRothWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForNatLangForm.TextInputForNatLangForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    values: values,
    setFieldValue: setFieldValue,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    htmlSize: htmlSize,
    preText: preText,
    postText: postText,
    prepend: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _TraditionalvRothWizardCalc.idPrefix + fieldName
  });
}
function CurrentContribution(_ref5) {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = _ref5;
  var fieldName = 'currentContribution';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '5';
  var placeholder = ' 0 ';
  var htmlSize = '4';
  var preText = ' . I contribute  ';
  var postText = ' of my salary toward my employer-sponsored retirement ';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      zeroAlways: false,
      allowDecimals: 2
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_TraditionalvRothWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForNatLangForm.TextInputForNatLangForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    values: values,
    setFieldValue: setFieldValue,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    htmlSize: htmlSize,
    preText: preText,
    postText: postText,
    append: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _TraditionalvRothWizardCalc.idPrefix + fieldName
  });
}
function EmployerMatchRate(_ref6) {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = _ref6;
  var fieldName = 'employerMatchRate';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '5';
  var placeholder = ' 0 ';
  var htmlSize = '4';
  var preText = ' My employer matches ';
  var postText = ' of ';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      zeroAlways: false,
      allowDecimals: 2
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_TraditionalvRothWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForNatLangForm.TextInputForNatLangForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    values: values,
    setFieldValue: setFieldValue,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    htmlSize: htmlSize,
    preText: preText,
    postText: postText,
    append: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _TraditionalvRothWizardCalc.idPrefix + fieldName
  });
}
function EmployerMatchLimit(_ref7) {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = _ref7;
  var fieldName = 'employerMatchLimit';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '5';
  var placeholder = ' 0 ';
  var htmlSize = '4';
  var preText = ' the first ';
  var postText = ' of salary contributed. ';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      zeroAlways: false,
      allowDecimals: 2
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_TraditionalvRothWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForNatLangForm.TextInputForNatLangForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    values: values,
    setFieldValue: setFieldValue,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    htmlSize: htmlSize,
    preText: preText,
    postText: postText,
    append: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _TraditionalvRothWizardCalc.idPrefix + fieldName
  });
}

// Dropdown inputs start here
function TaxRate(_ref8) {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = _ref8;
  var fieldName = 'lastYearTaxRate';
  var preText = ' was ';
  var postText = ' . ';
  var placeholderProp = ' 0% ';
  return /*#__PURE__*/_react.default.createElement(_DropdownForNatLangForm.DropdownForNatLangForm, {
    errors: errors,
    touched: touched,
    values: values,
    dropdownArray: _TraditionalvRothWizardCalc.dropdownOptions.lastYearTaxRatesArray,
    fieldName: fieldName,
    preText: preText,
    postText: postText,
    placeholderProp: placeholderProp,
    setFieldValue: setFieldValue,
    calcName: _TraditionalvRothWizardCalc.calcName
  });
}
function State(_ref9) {
  var {
    values,
    setFieldValue
  } = _ref9;
  var fieldName = 'state';
  var placeholderProp = 'Select your state';
  return /*#__PURE__*/_react.default.createElement(_DropdownForNatLangForm.DropdownForNatLangForm, {
    values: values,
    dropdownArray: _TraditionalvRothWizardCalc.dropdownOptions.statesArray,
    fieldName: fieldName,
    setFieldValue: setFieldValue,
    className: "endOfSentence",
    calcName: _TraditionalvRothWizardCalc.calcName,
    placeholderProp: placeholderProp
  });
}
function FilingStatus(_ref10) {
  var {
    values,
    setFieldValue
  } = _ref10;
  var fieldName = 'filingStatus';
  var preText = ' My federal tax filing status is ';
  return /*#__PURE__*/_react.default.createElement(_DropdownForNatLangForm.DropdownForNatLangForm, {
    values: values,
    dropdownArray: _TraditionalvRothWizardCalc.dropdownOptions.filingArray,
    fieldName: fieldName,
    setFieldValue: setFieldValue,
    preText: preText,
    className: "endOfSentence",
    calcName: _TraditionalvRothWizardCalc.calcName
  });
}
function RetTaxRate(_ref11) {
  var {
    values,
    setFieldValue
  } = _ref11;
  var fieldName = 'retTaxRate';
  var preText = ' I think that my tax bracket will be ';
  var postText = ' than it is now when I begin making withdrawals ';
  return /*#__PURE__*/_react.default.createElement(_DropdownForNatLangForm.DropdownForNatLangForm, {
    values: values,
    dropdownArray: _TraditionalvRothWizardCalc.dropdownOptions.retTaxRateArray,
    fieldName: fieldName,
    setFieldValue: setFieldValue,
    preText: preText,
    postText: postText,
    calcName: _TraditionalvRothWizardCalc.calcName
  });
}
function TaxPreference(_ref12) {
  var {
    values,
    setFieldValue
  } = _ref12;
  var fieldName = 'preference';
  var preText = ' . My preference is to pay taxes on my retirement contributions ';
  var postText = ' ';
  return /*#__PURE__*/_react.default.createElement(_DropdownForNatLangForm.DropdownForNatLangForm, {
    values: values,
    dropdownArray: _TraditionalvRothWizardCalc.dropdownOptions.taxPreferencesArray,
    fieldName: fieldName,
    setFieldValue: setFieldValue,
    preText: preText,
    postText: postText,
    calcName: _TraditionalvRothWizardCalc.calcName
  });
}
function PlanType(_ref13) {
  var {
    values,
    setFieldValue
  } = _ref13;
  var fieldName = 'planType';
  var preText = ' plan with ';
  var postText = ' dollars';
  return /*#__PURE__*/_react.default.createElement(_DropdownForNatLangForm.DropdownForNatLangForm, {
    values: values,
    dropdownArray: _TraditionalvRothWizardCalc.dropdownOptions.planTypeArray,
    fieldName: fieldName,
    setFieldValue: setFieldValue,
    preText: preText,
    postText: postText,
    calcName: _TraditionalvRothWizardCalc.calcName
  });
}
function EmployerMatchYN(_ref14) {
  var {
    values,
    setFieldValue
  } = _ref14;
  var fieldName = 'employerMatchYN';
  var preText = ', and my employer ';
  var postText = ' my contributions. ';
  return /*#__PURE__*/_react.default.createElement(_DropdownForNatLangForm.DropdownForNatLangForm, {
    values: values,
    dropdownArray: _TraditionalvRothWizardCalc.dropdownOptions.employerMatchYNArray,
    fieldName: fieldName,
    setFieldValue: setFieldValue,
    preText: preText,
    postText: postText,
    calcName: _TraditionalvRothWizardCalc.calcName
  });
}